import { render, staticRenderFns } from "./B2CViewCouponModal.vue?vue&type=template&id=56059fe0"
import script from "./B2CViewCouponModal.vue?vue&type=script&lang=ts"
export * from "./B2CViewCouponModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports